import {type IconProps} from './types'
import * as glyphs from './components/glyphs'

export const Icon = ({width, height, glyph, className}: React.PropsWithChildren<IconProps>) =>
    glyphs[glyph](width, height, className)
